import { createRoot } from "../../shared/utils/createRoot";
import App from "./app";
var Root = createRoot(App);
export default Root;



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/root.tsx
// module id = nGOu
// module chunks = 3